import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { ProgressThermometer } from '../../legacy-design-system/thermometer'

interface Props {
  readonly total: number
  readonly progress: number
}

export function DeleteOverlay({ progress, total }: Props) {
  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0.5);
      `}
    >
      <div
        className={css`
          position: relative;
          margin-left: auto;
          margin-right: auto;
          top: 60px;
          width: 380px;
          background-color: ${theme.color.neutral90};
          color: ${theme.color.white};
          opacity: 1;
          border-radius: 3px;
          padding: 16px;
        `}
      >
        <FormattedMessage
          values={{ count: total }}
          id="detail_vulnerabilities_deletingVulnerabilities"
        >
          {(text) => (
            <div
              className={css`
                margin-bottom: 4px;
              `}
            >
              {text}
            </div>
          )}
        </FormattedMessage>

        <ProgressThermometer
          progress={progress}
          maxProgress={total}
          fillColor="green50"
          bgColor="neutral100"
          renderProgress={({ width, className }) => {
            return <div className={className} style={{ width }} />
          }}
        />
      </div>
    </div>
  )
}
